/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import { Outlet, useParams } from 'react-router-dom';
import store from '../store';
import { appInitSaga } from '../reducers/app';
import { AppNotification } from '../components/app-notification';
import styled from 'styled-components';
import { Dispatch } from 'redux';
import { AppNav } from '../components/app-nav';
import { Sidebar } from 'semantic-ui-react';
import { DrawerPanel } from '../components/drawer-panel';
import { useDispatch } from 'react-redux';
import { closeBooth } from '../features/queues';
import { HEADER_HEIGHT } from '../components/layout/layout-components';

interface AppLayoutProps {}

function handleAppInit(dispatch: Dispatch, props: any) {
  const state = store.getState();
  if (!state.app.initialized) {
    dispatch(appInitSaga(props));
  }
}

const Container = styled.section`
  display: grid;
  height: 100vh;
  grid-template-rows: ${HEADER_HEIGHT} 1fr;
  padding-bottom: 20px;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function AppLayout(props: AppLayoutProps) {
  const contentRef = React.useRef(null);
  const [isSidebarVisible, setSidebarVisible] = useState(false);

  const dispatch = useDispatch();
  const params = useParams();

  const deviceUUID = params.device_uuid || '';
  useEffect(() => {
    handleAppInit(dispatch, { ...props, params });
  }, []);

  return (
    <>
      <Sidebar
        onHide={() => setSidebarVisible(false)}
        target={contentRef}
        visible={isSidebarVisible}
        animation="overlay"
      >
        <DrawerPanel
          onClick={() => setSidebarVisible(false)}
          uuidFromUrl={deviceUUID}
          closeBooth={() => dispatch(closeBooth())}
        />
      </Sidebar>
      <AppNotification />
      <Container ref={contentRef}>
        <AppNav onNavIconClick={() => setSidebarVisible(!isSidebarVisible)} />
        <Outlet />
      </Container>
    </>
  );
}
